<template>
  <!-- class="bggray2" style="padding: 15px; border-radius: 8px" -->
  <div>
    <a id="tagOpenWin" target="_blank"></a>
    <el-row :gutter="6" class="row-con">
      <el-col :span="7">
        <el-card class="card">
          <el-row :gutter="0">
            <el-col :span="24" style="display: flex; align-items: center">
              <div style="width: 110px; margin: 0 auto; flex-grow: 0.5">
                <img v-if="getUserInfo.f1" :src="getUserInfo.f1" width="99%" />
                <i v-else class="el-icon-picture-outline" style="font-size: 100px; color: #eee"></i>
                <!-- <p class="tc fb f16 fblue2">{{ getUserInfo.name }}</p> -->
              </div>
              <div style="margin-left: 15px; flex-grow: 2.5">
                <p class="fgreen fb">
                  <span class>姓&emsp;&emsp;&nbsp;名：</span>
                  {{ getUserInfo.name }}
                </p>
                <p class="mt6" v-if="getUserInfo.userid">
                  <span class="fb">学号/工号：</span>
                  {{ getUserInfo.userid }}
                </p>
                <p class="mt6" v-if="getUserInfo.department">
                  <span class="fb">部门/学院：</span>
                  {{ getUserInfo.department }}
                </p>
                <p class="mt6" v-if="getUserInfo.major">
                  <span class="fb">专&emsp;&emsp;&nbsp;业：</span>
                  {{ getUserInfo.major ? getUserInfo.major : "" }}
                </p>
                <p class="mt6" v-if="getUserInfo.bj">
                  <span class="fb">班&emsp;&emsp;&nbsp;级：</span>
                  {{ getUserInfo.bj ? getUserInfo.bj : "" }}
                </p>
              </div>
            </el-col>
            <!-- <el-col :span="16"  style="display: flex; align-items: center;height:120px">
             
          

            </el-col>-->
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="17">
        <el-card class="card" style="font-size: 16px" body-style="padding:5px 10px">
          <div slot="header" class="clearfix">
            <i
              class="el-icon-s-help"
              style="
                float: left;
                padding: 3px 0;
                color: #fcca00;
                margin-right: 5px;
              "
            ></i>
            <span class="fb">常用工具</span>
          </div>
          <el-row :gutter="6" type="flex" justify="space-between">
            <el-col :span="4" class="margincenter" @click.native="clickCircular()">
              <div class="iconCircular" style="background: #3ccd96">
                <i class="el-icon-date"></i>
              </div>
              <div style="margin-top: 8px">学校日历</div>
            </el-col>
            <el-col :span="4" class="margincenter" @click.native="clickCulum()">
              <div class="iconCircular" style="background: #ff96c0">
                <i class="el-icon-notebook-2"></i>
              </div>
              <div style="margin-top: 8px">我的课表</div>
            </el-col>
            <el-col
              :span="4"
              class="margincenter"
              @click.native="topages('/mailList')"
              v-if="getUserInfo.userType == 1"
            >
              <div class="iconCircular" style="background: #6fb6f7">
                <i class="el-icon-collection"></i>
              </div>
              <div style="margin-top: 8px">通讯录</div>
            </el-col>
            <el-col :span="4" class="margincenter" @click.native="clickNotice()">
              <div class="iconCircular" style="background: #06c1ae">
                <i class="el-icon-bell"></i>
              </div>
              <div style="margin-top: 8px">通知公告</div>
            </el-col>
            <!-- <el-col :span="4" class="margincenter">
              <div class="iconCircular" style="background: #fe9983">
                <i class="el-icon-s-data"></i>
              </div>
              <div style="margin-top: 8px">数据统计</div>
            </el-col>-->
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="6">
      <el-col :span="7">
        <div ref="left">
          <el-card>
            <div slot="header" class="clearfix" style="font-size: 16px">
              <i
                class="el-icon-message"
                style="
                  float: left;
                  padding: 3px 0;
                  color: #008a2c;
                  margin-right: 5px;
                "
              ></i>
              <span class="fb">我的消息</span>
              <i
                class="el-icon-more"
                style="
                  float: right;
                  padding: 3px 0;
                  color: #008a2c;
                  cursor: pointer;
                "
                @click="topages('/userMsg')"
                title="查看更多"
              ></i>
            </div>
            <div style="height: 155px;overflow: auto;" v-if="userMsgData.length != 0">
              <div
                v-for="item in userMsgData"
                :key="item.id"
                class="text item"
                style="cursor: pointer"
                @click="toMsgInfoPage(item)"
              >{{ item.msgSource }}:{{ item.msgTitle }} &nbsp;{{formatDate(item.createtime)}}</div>
            </div>
            <div class="f_gray tc" style="height: 155px" v-else>暂无消息</div>
          </el-card>
          <el-card class="followCard">
            <div slot="header" class="clearfix" style="font-size: 16px">
              <span style="float: left; color: #f94a56; margin-right: 5px">❤</span>
              <span class="fb">我的收藏</span>
              <i
                v-if="deleteFollow"
                class="el-icon-remove-outline"
                style="
                  float: right;
                  padding: 3px 0;
                  color: #008a2c;
                  cursor: pointer;
                "
                @click="deleteFollow = false"
              >管理</i>
              <i
                v-else
                class="el-icon-circle-check"
                style="
                  float: right;
                  padding: 3px 0;
                  color: #008a2c;
                  cursor: pointer;
                "
                @click="saveFollow"
              >保存</i>
            </div>
            <div style="height: 357px; overflow: auto">
              <el-row v-if="followService" :gutter="0" class="flex-col">
                <el-col
                  :span="8"
                  v-for="(item, index) in followService"
                  :key="item.id"
                  class="margincenter tc"
                >
                  <el-badge
                    :value="item.isFollow == 1 ? '×' : '♡'"
                    :type="item.isFollow == 1 ? 'info' : ''"
                    :hidden="deleteFollow"
                    @click.native="changefollowService(item.id, index)"
                  >
                    <div @click="topagesWithId('/serviceInfor', item.id)">
                      <!-- <svg
                        class="icon svg-icon"
                        aria-hidden="true"
                        style="font-size: 30px"
                      >
                        <use :xlink:href="'#icon-' + item.icon"></use>
                      </svg>-->
                      <i
                        class="icon iconfont"
                        :class="'icon-' + item.icon"
                        style="font-size: 30px; color: #3cba1a"
                      ></i>
                      <div style="margin: 8px 10px 0px 10px">{{ item.serviceName }}</div>
                    </div>
                  </el-badge>
                </el-col>
              </el-row>
              <div v-else class="f_gray tc">暂无收藏</div>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="17">
        <el-card body-style="padding:0px 10px">
          <div ref="hei1" slot="header" class="clearfix" style="font-size: 16px">
            <i
              class="el-icon-s-order"
              style="
                float: left;

                color: #008a2c;
                margin-right: 5px;
              "
            ></i>
            <span class="fb">我的事项</span>
          </div>
          <div ref="hei2" style="padding: 8px 30px">
            <el-tabs
              v-model="activeName"
              :stretch="true"
              @tab-click="
                pageIndex = 1;
                toServiceRun();
              "
            >
              <el-tab-pane label="待办事项" name="0"></el-tab-pane>
              <el-tab-pane label="已发事项" name="1"></el-tab-pane>
              <el-tab-pane label="已办事项" name="2"></el-tab-pane>
              <el-tab-pane label="全部" name="3"></el-tab-pane>
            </el-tabs>
            <div :style="{ height: height }" v-if="serviceByState.length != 0">
              <el-row
                style="
                  padding: 10px 10px 10px 20px;
                  border-bottom: 1px dotted #ccc;
                "
                v-for="item in serviceByState"
                :key="item.id"
              >
                <el-col :span="20">
                  <p class="fb fgreen" style="font-size: 16px">{{ item.f1 }}</p>
                  <p class="mt10">
                    <span class="fb">申请时间：</span>
                    {{ item.applyTime }}
                  </p>
                  <p class="mt10" v-if="activeName == 0">
                    <span class="fb">申请人：</span>
                    {{ item.applyUser }}
                  </p>
                  <p class="mt6">
                    <span class="fb">办结时间：</span>
                    {{ item.finishTime }}
                  </p>
                  <p class="mt6" v-if="activeName != '0'">
                    <span class="fb">当前状态：</span>
                    {{
                    item.runState == 0
                    ? "办理中"
                    : item.runState == 1
                    ? "已办结"
                    : "办理中"
                    }}
                  </p>
                </el-col>
                <el-col :span="4">
                  <div class="btn-box" style="height: 92px">
                    <div>
                      <!--不能删，占位-->
                    </div>
                    <div class="btn">
                      <!-- <el-button
                        v-if="activeName == 2"
                        type="success"
                        size="mini"
                        @click="evaluate(item)"
                        class="btn4"
                      >
                        立即评价
                      </el-button>-->
                      <el-button
                        v-if="activeName != 0"
                        type="success"
                        size="mini"
                        @click="toInfo(item)"
                        class="btn3"
                      >查看详情</el-button>
                      <el-button
                        v-else
                        type="success"
                        size="mini"
                        @click="toMatter(item)"
                        class="btn5"
                      >立即审批</el-button>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-else class="f_gray tc" :style="{ height: height }">
              <div style="height: 60px"></div>暂无数据
            </div>
          </div>
          <div style="clear: both"></div>
          <el-pagination
            style="margin: 20px"
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="pageSize"
            :current-page="pageIndex"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>
    <!-- <el-dialog
      title="系统评价"
      :visible.sync="dialogFormVisible"
      width="20%"
      top="30vh"
      :modal="false"
      center
      destroy-on-close
    >
      <el-row style="margin-bottom: 10px">
        <el-col :span="6"> 评&emsp;&emsp;分:</el-col>
        <el-col :span="18">
          <el-rate
            v-model="form.evalScore"
            :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
          >
          </el-rate>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6"> 评价内容:</el-col>
        <el-col :span="18">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="form.evalText"
          >
          </el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="commitEval" class="cancelButtonClass"
          >提 交</el-button
        >
        <el-button type="primary" @click="closeEval" class="confirmButtonClass"
          >取 消</el-button
        >
      </div>
    </el-dialog>-->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import "../../static/css/my.css"
import { mapGetters } from "vuex"
import moment from "moment"
import {
  followService,
  queryServiceInfo,
  queryYDMHtoken,
} from "@/api/serviceInfo"

import {
  queryWaitingRun,
  queryMyFollow,
  getUserMsg,
  commitServiceEval,
  queryServiceRun,
  updateServiceRun,
  queryDone,
  queryPending,
  getOA,
} from "@/api/myHome"
import { jsdtxgg, OAUrl } from '@/config/net.config.js'
// import { queryNoticeMoreUrl } from "@/api/notice"
export default {
  name: "userCenter",
  data () {
    return {
      ydmhtoken: "",
      jwtoken: "",
      circleUrl: "",
      url: "",
      serviceByState: [], //办理列表
      total: 0,
      pageIndex: 1,
      pageSize: 4,
      activeName: "0", //我的事项：当前选中状态，0-待办理，1-待评价，2-已评价，3-全部（传给后端为 空）
      height: "",
      followService: "", //我的收藏 数据
      userMsgData: "", //我的消息 数据
      deleteFollow: true, // 我的收藏是否修改状态
      dialogFormVisible: false, //立即评价弹框
      form: {
        runid: "",
        evalScore: 0,
        evalText: "",
        evalTime: "",
        evalUser: "",
        evalUserid: "",
      },
      serviceIdToUpdate: "",
    }
  },
  computed: {
    ...mapGetters(["getUserId", "getUserInfo"]),
  },
  destroyed () {
    window.removeEventListener("resize", this.setHeight)
  },
  mounted () {
    document.addEventListener("visibilitychange", () => {
      //浏览器tab标签切换事件
      if (document.visibilityState == "hidden") {
        //页面切换或者最小化
        //当页面切换或者最小化时，在此做其他方法操作，
        this.getOA(this.getUserInfo.userid)
      }
    })
    console.log("getUserInfogetUserInfo", this.getUserInfo)
    this.getOA(this.getUserInfo.userid)
    this.getMyFollow()

    this.getUserMsg()
    this.getYdmhToken() //获取移动门户token,教务TOKEN
    setTimeout(() => {
      this.setHeight()
      this.toServiceRun()
    }, 500)
    window.addEventListener("resize", this.setHeight)
  },
  methods: {
    formatDate (date) {
      if (date != null) {
        return moment(date).format("YYYY-MM-DD HH:mm:ss")
      } else {
        return ''
      }

    },
    // 设置列表高度
    setHeight () {
      var ref = this.$refs.left.scrollHeight
      this.height = ref - 185 + "px"
    },
    async getOA (userId) {
      await getOA(userId).then((res) => {
        console.log(res)
      })
    },
    // 查询我的消息
    async getUserMsg () {
      let searchData = [
        {
          name: "like_createuser",
          value: this.getUserInfo.userid,
        },
      ]
      let params = {
        searchData: JSON.stringify(searchData),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sortField: "createtime",
        sortOrder: "desc",
      }
      const data = await getUserMsg(params)
      if (data.msgCode == 0) {
        this.userMsgData = data.data
      }
    },
    // 查询 我的收藏
    async getMyFollow () {
      const data = await queryMyFollow()
      if (data.msgCode == 0) {
        if (data.data != null) {
          data.data.forEach((item) => {
            item.isFollow = 1
          })
        }
        this.followService = data.data
      } else if (data.msgCode == 200) {
        this.followService = []
      }
    },
    //查询OA
    async queryOA (state) {
      let data = {
        loginName: this.getUserInfo.userid,
        pageSize: this.pageSize,
        page: this.pageIndex,
      }
      if (state == "0") {
        await queryPending(data).then((res) => {
          console.log(res)
        })
      } else if (state == "2") {
        await queryDone(data).then((res) => {
          console.log(res)
        })
      } else if (state == "3") {
        await queryPending(data).then((res) => {
          console.log(res)
        })
        await queryDone(data).then((res) => {
          console.log(res)
        })
      }
    },
    // 移除 收藏
    removeFollow (id, index) {
      this.changefollowService(id, index)
    },
    // 保存收藏
    saveFollow () {
      this.deleteFollow = true
      this.getMyFollow()
    },
    // 收藏/取消收藏
    async changefollowService (id, index) {
      let data = await followService(id)

      if (data.msgCode == 200) {
        if (this.followService[index].isFollow == 0) {
          this.followService[index].isFollow = 1
        } else {
          this.followService[index].isFollow = 0
        }
      }
    },
    toServiceRun () {
      if (this.activeName == 0 || this.activeName == 3) {
        //代办和全部
        this.getWaitingRun()
      } else {
        // 已发和待评价
        this.getServiceRun()
      }
    },
    // 查询 待办事项 和 全部
    async getWaitingRun () {
      let state = this.activeName
      if (this.activeName == 3) {
        state = ""
      }
      const data = await queryWaitingRun(
        state,
        this.pageIndex,
        this.pageSize,
        ""
      )
      if (data.msgCode == 0) {
        if (data.data == null) {
          return
        }
        data.data.forEach((item) => {
          if (item.applyTime != null)
            item.applyTime = moment(item.applyTime).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          if (item.finishTime != null)
            item.finishTime = moment(item.finishTime).format(
              "YYYY-MM-DD HH:mm:ss"
            )
        })
        this.serviceByState = data.data
        this.total = data.total
      }
    },
    // 查询 已发事项 和 待评价
    async getServiceRun () {
      let params = {
        applyUserid: this.getUserId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }
      if (this.activeName == 2) {
        params.runState = 1
      }
      const data = await queryServiceRun(params)
      if (data.msgCode == 0) {
        if (data.data == null) {
          return
        }
        data.data.forEach((item) => {
          if (item.applyTime != null)
            item.applyTime = moment(item.applyTime).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          if (item.finishTime != null)
            item.finishTime = moment(item.finishTime).format(
              "YYYY-MM-DD HH:mm:ss"
            )
        })
        this.serviceByState = data.data
        this.total = data.total
      }
    },
    // 分页查询
    handleCurrentChange (val) {
      this.pageIndex = val
      this.toServiceRun()
    },
    followtip () {
      this.$message({
        showClose: true,
        message: "请先保存我的收藏！",
        type: "warning",
      })
    },
    toMsgInfoPage (msg) {
      if (this.deleteFollow) {
        sessionStorage.setItem("msgInfo", JSON.stringify(msg))
        this.$router.push("/userCenter/userMsgInfo")
      } else {
        this.followtip()
      }
    },
    // 我的事项 查看详情
    async toInfo (run) {
      console.log(run)
      if (run.sysName == "OA") {
        let href = ""
        if (run.applyUserid == this.getUserId) {
          href = run.applicantPcUrl
        } else {
          href = run.sysUrl
        }
        const aa = document.getElementById("tagOpenWin")
        aa.href = href
        aa.click()
        // window.location.href = run.sysUrl;
      } else {
        if (this.deleteFollow) {
          const data = await queryServiceInfo(run.serviceId)
          console.log(data)
          if (data.msgCode == 0) {
            sessionStorage.setItem("xzztcToken", data.data.serviceSecret)
            if (run.serviceId == "1575737654584291330") {
              this.$router.push("/feedbackDetail?id=" + run.serviceRunid)
            } else {
              this.$router.push(
                "/userCenter/matterInfo?detailid=" +
                run.serviceRunid +
                "&id=" +
                run.f4 +
                "&runid=" +
                run.id
              )
            }
          }
        } else {
          this.followtip()
        }
      }
    },
    async toMatter (run) {
      if (run.sysName == "OA") {
        window.open(run.sysUrl, "_blank")
      } else {
        if (this.deleteFollow) {
          const data = await queryServiceInfo(run.serviceId)

          if (data.msgCode == 0) {
            sessionStorage.setItem("xzztcToken", data.data.serviceSecret)

            this.$router.push(
              "/userCenter/matterApproval?detailid=" +
              run.serviceRunid +
              "&id=" +
              run.f4 +
              "&runid=" +
              run.id
            )
          }
        } else {
          this.followtip()
        }
      }
    },
    clickCircular () {
      if (this.deleteFollow) {
        this.$router.push({
          path: "/userCenter/schoolCalendar",
          query: { jwtoken: this.jwtoken },
        })
      } else {
        this.followtip()
      }
    },
    clickCulum () {
      if (this.deleteFollow) {
        if (this.getUserInfo.userType == "1") {
          this.$router.push({
            path: "/userCenter/curriculum_teacher",
            query: { jwtoken: this.jwtoken },
          })
        } else if (this.getUserInfo.userType == "0") {
          this.$router.push({
            path: "/userCenter/curriculum_stu",
            query: { jwtoken: this.jwtoken },
          })
        }
      } else {
        this.followtip()
      }
    },
    async clickNotice () {
      if (this.deleteFollow) {


        if (this.getUserInfo.userType == "1") {
          //老师
          // let params = {
          //   userid: this.getUserInfo.userid,
          // };
          // // console.log(this.ydmhtoken); //移动门户token
          // const data = await queryNoticeMoreUrl(params, this.ydmhtoken);
          // if (data.msgCode == 0) {
          //   loading.close();
          //   const aa = document.getElementById("tagOpenWin");
          //   const href = data.object.noticeMoreUrl;
          //   aa.href = href;
          //   aa.click();
          // }
          const oa = window.open(OAUrl, "_blank")
          setTimeout(() => {
            //this.infoData.sysUrl 需要打开的表单地址
            oa.location.href = jsdtxgg
          }, 500)
          // window.open(jsdtxgg, '_blank')
        } else if (this.getUserInfo.userType == "0") {
          const loading = this.$loading({
            lock: true,
            text: "请稍等...",
            spinner: "el-icon-loading",
          })
          //学生
          console.log(this.ydmhtoken)
          this.$router.push({
            path: "userCenter/notice",
            query: { ydmhtoken: this.ydmhtoken },
          })
          loading.close()
        }
      } else {
        this.followtip()
      }
    },
    topages (path) {
      if (this.deleteFollow) {
        this.$router.push("/userCenter" + path)
      } else {
        this.followtip()
      }
    },
    topagesWithId (path, id) {
      if (this.deleteFollow) {
        this.$router.push(path + "?id=" + id)
      } else if (!this.deleteFollow && path == "/serviceInfor") {
        // 我的收藏修改时，不能点击服务进入详情
        return
      } else {
        this.followtip()
      }
    },
    //立即评价
    evaluate (item) {
      this.dialogFormVisible = true
      this.form.runid = item.id
      this.form.evalUser = this.getUserInfo.name
      this.form.evalUserid = this.getUserInfo.id
      this.serviceIdToUpdate = item.serviceId
    },
    // 提交评分
    async commitEval () {
      this.form.evalTime = new Date()
      this.form.evalScore *= 20
      const data = await commitServiceEval(this.form)
      if (data.msgCode == 200) {
        this.updateServiceRun()
      }
    },
    // 更改评分状态
    async updateServiceRun () {
      let params = {
        serviceId: this.serviceIdToUpdate,
        applyUser: this.form.evalUser,
        applyUserid: this.form.evalUserid,
        runState: 2,
        evalScore: this.form.evalScore,
        id: this.form.runid,
      }
      const data = await updateServiceRun(params)
      if (data.msgCode == 200) {
        this.closeEval()
        this.toServiceRun()
      }
    },
    closeEval () {
      this.dialogFormVisible = false
      this.form = []
    },
    //获取移动门户token
    async getYdmhToken () {
      console.log(this.getUserInfo)
      const data = await queryYDMHtoken(this.getUserInfo.userid)
      console.log(data)
      this.ydmhtoken = data.data.ydmh
      this.jwtoken = data.data.jwxt
    },
  },

  components: {
    // HelloWorld
  },
};
</script>
<style>
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #dfdddd;
  color: #868686;
}

.mt6 {
  margin-top: 5px;
}

.yscroll {
  overflow-y: scroll;
}

.el-card {
  margin: 5px;
}

.margincenter {
  margin: 8px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.el-tabs__active-bar {
  background-color: #00881f;
  height: 4px;
}

.el-tabs__item:hover {
  color: #00881f;
}

.row-con {
  display: flex;
  flex-flow: row wrap;
}

.row-con .card {
  height: 95%;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 8px;
  padding-bottom: 8px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.el-badge__content.is-fixed {
  position: absolute;
  top: 0;
  right: 30px;
  transform: translateY(-40%) translateX(100%);
}

.el-badge__content {
  font-size: 14px;
}

.btn-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.btn {
  display: flex;
  justify-content: right;
}

.btn3.el-button {
  background-color: #008a2c;
}

.btn3.el-button:hover {
  color: #008a2c;
  border-color: #e0fae8;
  background-color: #c6f6d5b7;
}

.btn4.el-button {
  background-color: #fb720c;
  border: none;
}

.btn4.el-button:hover {
  /* color: #fb720c; */
  border-color: #fb720c;
  background-color: #ffbf98;
}

.btn5.el-button {
  background-color: #008a2c;
}

.btn5.el-button:hover {
  color: #008a2c;
  border-color: #e0fae8;
  background-color: #c6f6d5b7;
}

.el-dialog__header {
  background-color: #00881f !important;
}

.el-dialog__title {
  color: white;
}
.iconCircular {
  width: 70px;
  height: 70px;
  background: #eee;
  text-align: center;
  border-radius: 50%;
}
.iconCircular i {
  font-size: 45px;
  line-height: 70px;
  color: #fff;
}
:deep .el-card__header {
  padding: 10px !important;
}
:deep .el-badge__content.is-fixed {
  top: -5px;
  right: 0px;
  transform: translateY(0%) translateX(0%);
}
/* /deep/ .el-card__header {
  padding: 10px !important;
}
/deep/ .el-badge__content.is-fixed {
  top: -5px;
  right: 0px;
  transform: translateY(0%) translateX(0%);
} */
</style>
